import { createStoreWithSetters } from './utils';

interface IStoreProps {
  cloudManageOpen: boolean;
  completeDownloadList: number[];
}

export const useCloudManageStore = createStoreWithSetters<IStoreProps>(
  {
    cloudManageOpen: false,
    completeDownloadList: [],
  },
  'cloud_manage',
);
